export default () => ({
  siwfData: null,
});
